module.exports = __webpack_public_path__ + "img/291622ad2486f6a754d9cd96859bfc7f.png";